/* eslint-disable max-lines */
import { SearchOutlined } from '@ant-design/icons';
import { Button, Drawer, Input, Row, Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { GithubRepositories } from '../../../../constants/AppConstants';
import CloseIcon from '../../../../assets/icons/close-icon.svg';
import { SideBarKey } from '../Sidebar/SidebarConstants';
import { SidebarActions } from '../../../../libs/store/actions/SidebarActions';
import './GithubLinksStyles.less';

interface IGithubLinksProps {
  visible: boolean;
}

const GithubLinks = ({ visible }: IGithubLinksProps) => {
  const dispatch = useDispatch();

  const dispatcher = {
    handleClose: () => dispatch(SidebarActions.setSidebarKey(SideBarKey.DASHBOARD)),
  };

  const [filteredRepositories, setFilteredRepositories] =
    useState<Array<{ label: string; link: string }>>(GithubRepositories);

  const getTableColumns = (): ColumnsType<{ label: string; link: string }> => {
    return [
      {
        title: 'S No.',
        dataIndex: 'label',
        width: '15%',
        render: (_, __, index) => `${String(index + 1).padStart(2, '0')}`,
      },
      {
        title: 'Names',
        dataIndex: 'label',
        width: '25%',
      },
      {
        title: 'Github links',
        dataIndex: 'link',
        width: '60%',
        render: (value) => (
          <a target={'_blank'} href={value} rel={'noreferrer'} className={'github-link-text'}>
            {value}
          </a>
        ),
      },
    ];
  };

  const onSearch = (value: string) => {
    if (value === '') {
      setFilteredRepositories(GithubRepositories);
    } else {
      setFilteredRepositories(
        GithubRepositories.filter((repo) => {
          return (JSON.stringify(repo).toLowerCase().match(value.toLowerCase()) || []).length > 0;
        }),
      );
    }
  };

  return (
    <Drawer
      className="github-repository-drawer"
      title={'Github Repository'}
      placement="right"
      width="50%"
      onClose={() => dispatcher.handleClose()}
      open={visible}
      closeIcon={<img src={CloseIcon} alt="close" className="github-repository-drawer-close-btn" />}
    >
      <div className="github-repository-header">
        <span className="github-repository-title">{'Github Repository List'}</span>
        <Input.Search
          className="github-repository-search"
          addonBefore={<SearchOutlined />}
          placeholder={'Search ...'}
          allowClear
          enterButton={null}
          onChange={(e) => onSearch(e.target.value)}
        />
      </div>
      <Table
        className="github-repository-table"
        rowClassName={(_, index) => (index % 2 === 0 ? 'table-row-light' : 'table-row-dark')}
        columns={getTableColumns()}
        dataSource={filteredRepositories}
        pagination={false}
      />
    </Drawer>
  );
};

export default GithubLinks;
